// extracted by mini-css-extract-plugin
export default {"badge":"Cards_badge__z3b3Y","cards":"Cards_cards__h-jF6","img":"Cards_img__H+zxC","content":"Cards_content__TmkRs"};